import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScaleLoader } from 'halogen';

import '../styles/default-loader.css';

class DefaultLoader extends Component {
  render() {
    const { text } = this.props;
    const { t } = this.context;

    return (
      <div className="default-loader-container">
        <div className="default-loader-container__wrapper">
          <ScaleLoader color={'#020305'} />
          <p>{t(text || 'COMMON.DEFAULT_LOADER_MESSAGE')}</p>
        </div>
      </div>
    );
  }
}

DefaultLoader.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DefaultLoader;



// WEBPACK FOOTER //
// ./src/app/shared/default-loader/components/default-loader.js